import { SVGProps } from "react";

const Filter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.45399 2.68164H16.5457C17.47 2.68164 18.2262 3.43789 18.2262 4.3622V6.21081C18.2262 6.88303 17.8061 7.72331 17.3859 8.14345L13.7727 11.3365C13.2686 11.7566 12.9325 12.5969 12.9325 13.2691V16.8823C12.9325 17.3865 12.5964 18.0587 12.1762 18.3108L10.9998 19.0671C9.90747 19.7393 8.39496 18.983 8.39496 17.6386V13.1851C8.39496 12.5969 8.05885 11.8407 7.72274 11.4205L4.52969 8.05942C4.10955 7.63928 3.77344 6.88303 3.77344 6.37886V4.44622C3.77344 3.43789 4.52969 2.68164 5.45399 2.68164Z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Filter;
